export default __webpack_public_path__ + "static/media/moonozPic.e46ae45f.jpg";